module.exports = "<div class=\"form-control component-input-control\"> {{#if unvisible}} <p class=info>权限受限</p> {{else if be_control_condition}} <p class=info>被修改条件限制</p> {{else}} <input type=text class=\"search dynamic-form-input ui-width\" value={{value}}> <div style=float:left class=form-print-icon> {{#if required}} <span id=requiredLogo class={{requiredClass}}></span> {{/if}} </div> <span class=error> <div class=error-msg id=error_tip style=display:none> <em class=ui-error-arrow></em> <pre>{{ regErrorMsg }}</pre> </div> </span> {{/if}} </div>";


//////////////////
// WEBPACK FOOTER
// ./app/components/form/input-control/input-control.html
// module id = 1932
// module chunks = 50